import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC1CAHsy-zrsrrPf8FXYcpEzMHU4tdRlrk",
  authDomain: "orizon-cnc-generator.com",
  projectId: "orizon-cnc-generator",
  storageBucket: "orizon-cnc-generator.firebasestorage.app",
  messagingSenderId: "908516548118",
  appId: "1:908516548118:web:95b3567c7ce0cf6a2f9f37",
  measurementId: "G-DTS9TPWPVD"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app, "cnc-generator");
export const googleProvider = new GoogleAuthProvider();


// 🔐 Analytics controllato da consenso cookie

export let analytics = null;

export const initAnalytics = () => {

  if (typeof window !== "undefined") {

    const consent = localStorage.getItem("cookieConsent");

    if (consent === "accepted") {

      analytics = getAnalytics(app);

      console.log("Firebase Analytics enabled");

    }

  }

};

export default app;
